import { render } from "./SimpleTablePag.vue?vue&type=template&id=3a4b80fa"
import script from "./SimpleTablePag.vue?vue&type=script&lang=js"
export * from "./SimpleTablePag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__